export default __webpack_public_path__ + "static/media/logosN3.719749e6.jpg";